"use client"

import { ScopeProvider } from "bunshi/react"
import { NftSearchScope } from "./scope"
import type { ScopeState } from "./scope"

interface Props {
  children: React.ReactNode
  state: ScopeState
}

export function NftSearchScopeProvider({ children, state }: Props) {
  return (
    <ScopeProvider scope={NftSearchScope} value={state}>
      {children}
    </ScopeProvider>
  )
}
